import React, { useState, useEffect } from "react";
import { reportsService } from "../services/api";
const statusColors = { submitted: "#E65100", in_progress: "#1565C0", resolved: "#1A5C2A", rejected: "#D32F2F" };
const statusLabels = { submitted: "Soumis", in_progress: "En cours", resolved: "Résolu", rejected: "Rejeté" };
const categoryLabels = { road: "Route/Voirie", water: "Eau", waste: "Déchets", lighting: "Éclairage", security: "Sécurité", other: "Autre" };
export default function ReportsPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [response, setResponse] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const [filter, setFilter] = useState("all");
  useEffect(() => { loadReports(); }, []);
  const loadReports = () => {
    setLoading(true);
    reportsService.getReports().then(r => { setReports(r.data); setLoading(false); }).catch(() => setLoading(false));
  };
  const handleUpdate = async () => {
    if (!selected) return;
    try {
      await reportsService.updateReport(selected.id, { status: newStatus || selected.status, admin_response: response });
      setSelected(null);
      setResponse("");
      setNewStatus("");
      loadReports();
      alert("Signalement mis à jour!");
    } catch { alert("Erreur"); }
  };
  const filtered = filter === "all" ? reports : reports.filter(r => r.status === filter);
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ color: "#1A1A2E", fontSize: 24, fontWeight: 800, margin: 0 }}>Signalements</h1>
        <p style={{ color: "#8A8A9A", fontSize: 14, margin: "4px 0 0" }}>{reports.length} signalement(s) au total</p>
      </div>
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        {["all", "submitted", "in_progress", "resolved", "rejected"].map(s => (
          <button key={s} onClick={() => setFilter(s)}
            style={{ padding: "8px 16px", borderRadius: 10, border: "none", cursor: "pointer", fontFamily: "Poppins", fontSize: 12, fontWeight: 600, background: filter === s ? "#1A5C2A" : "#F5F6FA", color: filter === s ? "white" : "#8A8A9A" }}>
            {s === "all" ? "Tous" : statusLabels[s]}
          </button>
        ))}
      </div>
      {selected && (
        <div style={{ background: "white", borderRadius: 20, padding: 28, marginBottom: 24, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", border: "2px solid #1A5C2A" }}>
          <h3 style={{ margin: "0 0 16px", color: "#1A1A2E" }}>Répondre: {selected.title}</h3>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1A2E", display: "block", marginBottom: 6 }}>Nouveau statut</label>
            <select value={newStatus || selected.status} onChange={e => setNewStatus(e.target.value)}
              style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none" }}>
              <option value="submitted">Soumis</option>
              <option value="in_progress">En cours</option>
              <option value="resolved">Résolu</option>
              <option value="rejected">Rejeté</option>
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: "#1A1A2E", display: "block", marginBottom: 6 }}>Réponse au citoyen</label>
            <textarea value={response} onChange={e => setResponse(e.target.value)} rows={4} placeholder="Votre réponse..."
              style={{ width: "100%", padding: "10px 14px", border: "1px solid #E8E8F0", borderRadius: 10, fontSize: 14, fontFamily: "Poppins", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <button onClick={handleUpdate} style={{ background: "#1A5C2A", color: "white", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins" }}>Enregistrer</button>
            <button onClick={() => setSelected(null)} style={{ background: "#F5F6FA", color: "#8A8A9A", border: "none", padding: "10px 24px", borderRadius: 10, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins" }}>Annuler</button>
          </div>
        </div>
      )}
      {loading ? <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Chargement...</div> : (
        <div style={{ display: "grid", gap: 12 }}>
          {filtered.map(r => (
            <div key={r.id} style={{ background: "white", borderRadius: 16, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderLeft: `4px solid ${statusColors[r.status] || "#8A8A9A"}` }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <span style={{ background: (statusColors[r.status] || "#8A8A9A") + "20", color: statusColors[r.status] || "#8A8A9A", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>
                    {statusLabels[r.status] || r.status}
                  </span>
                  {r.is_urgent && <span style={{ background: "#D32F2F20", color: "#D32F2F", padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>🚨 URGENT</span>}
                  <span style={{ background: "#F5F6FA", color: "#8A8A9A", padding: "3px 10px", borderRadius: 6, fontSize: 11 }}>{categoryLabels[r.category] || r.category}</span>
                </div>
                <h3 style={{ margin: "0 0 4px", fontSize: 15, fontWeight: 700, color: "#1A1A2E" }}>{r.title}</h3>
                <p style={{ margin: "0 0 6px", fontSize: 13, color: "#8A8A9A" }}>{r.description?.substring(0, 100)}...</p>
                <p style={{ margin: 0, fontSize: 11, color: "#8A8A9A" }}>👤 {r.citizen?.full_name || "Citoyen"} • 📍 {r.location || "Non précisé"}</p>
                {r.admin_response && <p style={{ margin: "8px 0 0", fontSize: 12, color: "#1A5C2A", background: "#1A5C2A10", padding: "6px 10px", borderRadius: 8 }}>↩️ {r.admin_response}</p>}
              </div>
              <button onClick={() => { setSelected(r); setResponse(r.admin_response || ""); setNewStatus(r.status); }}
                style={{ background: "#1A5C2A20", color: "#1A5C2A", border: "none", padding: "8px 16px", borderRadius: 8, cursor: "pointer", fontSize: 13, fontWeight: 600, fontFamily: "Poppins", marginLeft: 16, whiteSpace: "nowrap" }}>
                Répondre
              </button>
            </div>
          ))}
          {filtered.length === 0 && <div style={{ textAlign: "center", padding: 60, color: "#8A8A9A" }}>Aucun signalement</div>}
        </div>
      )}
    </div>
  );
}